<template>
  <section>
  <qx-card title="列表">
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" :selectable="judgeSelect"/>
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
            >
              <section  slot-scope="scope">
                <!-- 是否在围栏中 -->
                <section v-if="scope.column.property === 'isBind'">
                  <span>{{scope.row.isBind===1?'是'+'（'+scope.row.fenceName+'）':'否' }}</span>
                </section>
                <!-- 是否在围栏中 end -->
                <section v-else>{{scope.row[scope.column.property]}}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->

    </section>
  </qx-card>

  </section>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {doQueryFenceVehicleBinding} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectTar: 'plateNumber',
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'orgName', label: '所属部门'},
          {prop: 'plateNumber', label: '车牌号'},
          {prop: 'isBind', label: '是否在围栏中'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryFenceVehicleBinding,

    handleSubSucc (res) {
      if (this.tableData.selectResult.length > 0) {
        return;
      }
      this.tableData.selectResult = res.fenceVehicleBindingList;
    },
    judgeSelect (row) {
      if (row.isBind === 1) {
        if (row.fenceId !== Number(this.$route.query.fenceId)) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
